import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ArrowRightIcon, FileText } from "lucide-react";
import { BriefSection } from "@/types/types";

interface ModeSwitchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allSections: BriefSection[];
  onConfirm: () => void;
}

export function ModeSwitchDialog({
  open,
  onOpenChange,
  allSections,
  onConfirm,
}: ModeSwitchDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-3xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Switch to freeform mode?</AlertDialogTitle>
          <AlertDialogDescription>
            Your guided sections will be combined into a single document.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-row justify-between items-center gap-5 md:p-5 p-2">
          <div className="flex flex-col items-center">
            {allSections.map((section, index) => (
              <div key={section.id} className="flex flex-col items-center">
                <div className="text-xs p-1.5 rounded-sm border border-dashed w-64 text-center">
                  {section.title}
                </div>
                {index < allSections.length - 1 && (
                  <span className="h-2 border-r border-dashed" />
                )}
              </div>
            ))}
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <span className="bg-primary/10 text-primary rounded-pill p-2 ring-4 ring-primary/5">
              <ArrowRightIcon className="size-4" />
            </span>
          </div>
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed w-64 p-1 text-center h-full">
            <div className="flex flex-col gap-4 items-center justify-center rounded-lg border border-dashed w-full text-center h-full text-xs font-medium">
              <FileText className="size-5 opacity-60" />
              One Large Brief
            </div>
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Switch to freeform mode</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
